export default class GameSoundVars {
    public static "GAME_START" = "game_start";
    public static "IDLE_MUSIC" = "idleBackgroundMusic";
    public static "BIG_WIN_PRE" = "big_win_pre";
    public static "BIG_WIN" = "big_win";
    public static "BIG_WIN_COINS" = "big_win_coins";
    public static "FREE_SPINS_COMPLETED" = "free_spins_completed";
    public static "REEL_ANTICIPATION_NO_WIN" = "reel_anticipation_no_win";
    public static "SCATTER_UNLOCK" = "scatter_unlock";
    public static "FREE_SPINS_INTRO" = "free_spins_intro";
    public static "BLACK_SPELL_EXPAND" = "black_spell_expand";
    public static "BN2_MULTIPLIER_UP" = "multiplier_up";
    public static "BN2_STICKY_WILD_LAND" = "sticky_wild_land";
}